import { ArrowUp } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = ({ onNavigate }) => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-[#07090E]">
    <div className="pointer-events-none select-none absolute -bottom-10 left-1/2 -translate-x-1/2 font-display font-extrabold uppercase tracking-tighter text-[26vw] leading-none text-outline whitespace-nowrap">
      AMP 01
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-40 md:pb-56">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <span className="rounded-md bg-white px-2 py-1 flex items-center">
              <img src="/logo-emblem.png" alt="Logo AMP Services 01" className="h-9 w-auto" />
            </span>
            <div className="leading-none">
              <div className="font-display font-extrabold uppercase tracking-tight">Auto Meca Pro</div>
              <div className="font-mono-tech text-[10px] tracking-[0.3em] text-[#00E5FF] uppercase mt-1">AMP Services 01</div>
            </div>
          </div>
          <p className="mt-6 text-sm text-slate-400 leading-relaxed max-w-xs">
            Garage automobile toutes marques à Bellignat. Entretien, réparation, diagnostic,
            pneumatiques et vente de véhicules.
          </p>
        </div>

        <div>
          <div className="font-mono-tech text-xs uppercase tracking-[0.3em] text-slate-500 mb-5">Navigation</div>
          <ul className="space-y-3 text-sm">
            {[
              ["#garage", "Le Garage", "footer-link-garage"],
              ["#services", "Services", "footer-link-services"],
              ["#vehicules", "Véhicules à vendre", "footer-link-vehicules"],
              ["#avis", "Avis Google", "footer-link-avis"],
              ["#faq", "Questions fréquentes", "footer-link-faq"],
              ["#horaires", "Horaires & Accès", "footer-link-horaires"],
              ["#contact", "Contact & Devis", "footer-link-contact"],
            ].map(([id, label, testId]) => (
              <li key={id}>
                <button
                  data-testid={testId}
                  onClick={() => onNavigate(id)}
                  className="text-slate-300 hover:text-white transition-colors duration-300"
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="font-mono-tech text-xs uppercase tracking-[0.3em] text-slate-500 mb-5">Infos</div>
          <ul className="space-y-3 text-sm text-slate-300">
            <li>56 Avenue d'Oyonnax</li>
            <li>01100 Bellignat — Ain (01)</li>
            <li>
              <a data-testid="footer-phone-link" href="tel:+33426612733" className="hover:text-white transition-colors duration-300">04 26 61 27 33</a>
            </li>
            <li>
              <a data-testid="footer-email-link" href="mailto:contact@automecapro01.com" className="hover:text-white transition-colors duration-300">contact@automecapro01.com</a>
            </li>
            <li>Lun – Ven : 9h–12h / 14h–19h</li>
            <li>Samedi : 9h–14h</li>
          </ul>
          <Link
            data-testid="footer-link-admin"
            to="/admin"
            className="inline-block mt-6 text-xs font-mono-tech uppercase tracking-[0.2em] text-slate-500 hover:text-[#00E5FF] transition-colors duration-300"
          >
            Espace Pro
          </Link>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="text-xs text-slate-500">
          © 2026 AUTO MECA PRO — SIRET 991 231 770 00017 — RCS Bourg-en-Bresse
        </div>
        <button
          data-testid="footer-back-to-top"
          onClick={() => onNavigate("#accueil")}
          className="flex items-center gap-2 text-xs font-mono-tech uppercase tracking-[0.2em] text-slate-400 hover:text-white transition-colors duration-300"
        >
          Haut de page
          <ArrowUp className="w-4 h-4" />
        </button>
      </div>
    </div>
  </footer>
);
